import { render } from "./TextSectionContent.vue?vue&type=template&id=4ea10f28&ts=true"
import script from "./TextSectionContent.vue?vue&type=script&lang=ts"
export * from "./TextSectionContent.vue?vue&type=script&lang=ts"

import "./TextSectionContent.vue?vue&type=style&index=0&id=4ea10f28&lang=scss"

import exportComponent from "C:\\Arbeit\\wordpress_projekte\\castroper-klimahelden\\wp-content\\themes\\cas-klimahelden-theme\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__